<h1 mat-dialog-title data-test="core-confirmation-title">{{ data.title }}</h1>
<div mat-dialog-content>
  <p data-test="core-confirmation-body">{{ data.body }}</p>
</div>

<!-- 3-button mode -->
@if (data.mode === 'delete-disable') {
  <div mat-dialog-actions class="d-flex justify-content-end align-items-center">
    <button
      mat-stroked-button
      [color]="data.cancelColour"
      (click)="cancel()"
      data-test="core-confirmation-cancel-button"
    >
      {{ data.cancelText }}
    </button>
    <button
      mat-flat-button
      [color]="data.disableColour"
      (click)="disable()"
      data-test="core-confirmation-disable-button"
    >
      {{ data.disableText }}
    </button>
    <button
      mat-flat-button
      [color]="data.deleteColour"
      (click)="delete()"
      cdkFocusInitial
      data-test="core-confirmation-delete-button"
    >
      {{ data.deleteText }}
    </button>
  </div>
} @else {
  <!-- fallback 2-button mode -->
  <div mat-dialog-actions class="d-flex justify-content-end align-items-center">
    <button
      mat-stroked-button
      [color]="data.declineColour"
      (click)="decline()"
      data-test="core-confirmation-decline-button"
    >
      {{ data.declineText }}
    </button>
    <button
      mat-flat-button
      [color]="data.confirmColour"
      (click)="confirm()"
      cdkFocusInitial
      data-test="core-confirmation-confirm-button"
    >
      {{ data.confirmText }}
    </button>
  </div>
}
